import React from "react";
import { Link } from "react-router-dom";
import "bootstrap-icons/font/bootstrap-icons.css";
import Logo from "../images/logo.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faTiktok,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";

import "../styles/footer.css";

const Footer = () => {
  return (
    <div className="footer-section">
      <div className="container">
        <div className="row">
          <div className="col-md-4">
            <div className="footer-first">
              <div className="logo-main">
                <img src={Logo} alt="Logo" />
                <p>
                Build force construction & service is one of the leading project development and construction company. We are active in corporate, private &  government project in national level.
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div>
              <h5 className="footer-space">Our Services</h5>
              <p>
                <Link to="/">Home</Link>
              </p>
              <p>
                <Link to="/projects">Projects</Link>
              </p>
              <p>
                <Link to="/service">Service</Link>
              </p>
              <p>
                <Link to="/about-us">About Us</Link>
              </p>
              <p>
                <Link to="/contact-us">Contact Us</Link>
              </p>
            </div>
          </div>
          <div className="col-md-5">
            <div className="map-footer">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3532.422339119719!2d85.3501696!3d27.704243500000004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39eb19a12c131023%3A0x9880952c15e30d5e!2sHotel%20Ananda%20Pashupati!5e0!3m2!1sen!2snp!4v1739772883540!5m2!1sen!2snp"
                width="100%"
                height="250"
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Google Maps"
              ></iframe>
            </div>
          </div>
          <div className="col-md-12 contact-details-main">
            <div className="row">
              <div className="col-md-9 contact-details">
                <div className="email-footer">
                  <i className="bi bi-envelope-check-fill"></i>
                  <p>bfcsnpl@gmail.com</p>
                </div>
                <div className="phone-footer">
                  <i className="bi bi-telephone-fill"></i>
                  <p>+977-9851218162, &nbsp;&nbsp;9841078162</p>
                </div>
              </div>
              <div className="col-md-3 social-icons">
                <a
                  href="https://www.facebook.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FontAwesomeIcon
                    icon={faFacebook}
                    style={{ color: "#ffffff" }}
                  />{" "}
                </a>
                <a
                  href="https://wa.me/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FontAwesomeIcon
                    icon={faWhatsapp}
                    style={{ color: "#ffffff" }}
                  />{" "}
                </a>
                <a
                  href="https://www.facebook.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FontAwesomeIcon
                    icon={faTiktok}
                    style={{ color: "#ffffff" }}
                  />{" "}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
